<template>
  <section class="cr-list ctx-list" aria-label="Product records">
    <div class="cr-list__head">
      <div class="cr-list__columns ctx-list__columns" aria-hidden="true">
        <span>Product name</span>
        <span>Files</span>
        <span>Status</span>
        <span>Created</span>
        <span>Actions</span>
      </div>
    </div>

    <div class="cr-list__scroll">
      <div v-if="loading" class="cr-list__body">
        <div v-for="n in 8" :key="n" class="cr-row cr-row--skeleton" />
      </div>

      <div v-else-if="contexts.length" class="cr-list__body" role="list">
        <ContextsRow
          v-for="context in contexts"
          :key="context.id"
          :context="context"
          @view="$emit('view', $event)"
          @edit="$emit('edit', $event)"
          @enable="$emit('enable', $event)"
          @disable="$emit('disable', $event)"
          @delete="$emit('delete', $event)"
        />
      </div>

      <div v-else-if="isSearchActive" class="cr-empty">
        <v-icon icon="mdi-magnify-close" size="40" class="cr-empty__icon" />
        <p class="cr-empty__title">No matching products</p>
        <p class="cr-empty__subtitle">
          Try another search or clear the app bar filter.
        </p>
      </div>

      <div v-else class="cr-empty">
        <v-icon icon="mdi-bookshelf" size="40" class="cr-empty__icon" />
        <p class="cr-empty__title">No products yet</p>
        <p class="cr-empty__subtitle">
          Create a product to organise knowledge and conversation settings for your AI agent.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import ContextsRow from '@/components/Contexts/ContextsRow.vue'

defineOptions({ name: 'ContextsList' })

defineProps({
  contexts: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
})

defineEmits(['view', 'edit', 'enable', 'disable', 'delete'])
</script>
